import { primaryColor, lightGrey } from '~/colors'

export default {
    characteristicsHeader: {
        fontSize: 15
    },
    characteristics: {
        borderTopWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: lightGrey,
        padding: 16
    },
    characteristicName: {
        marginBottom: 0,
        paddingLeft: 16
    },
    characteristicValue: {
        marginBottom: 0,
        color: primaryColor
    },
    characteristic: {
        borderBottomWidth: 1,
        borderColor: lightGrey,
        paddingBottom: 2,
        marginBottom: 4
    },
    lastCharacteristic: {}
}



// WEBPACK FOOTER //
// ./src/components/ProductCharacteristics/styles.js